import React, { Component } from "react";
import {
  companyCode,
  FSessionId,
  Focus8WAPI,
  InDocNo,
  InDate,
  JobWorkRefNo,
  modifiedJobWorkRefNo,
} from "./MainClient";
import { GlobalValues } from "./FClient_Responses";
import Spinner from "./components/spinner";

var host = window.serverUrl;
console.log("serverUrl: ", host);

export class App extends Component {
  state = {
    isLoading: true,
    tableData: [],

    HeaderData: {},
    FinalData: [],
    // FinalData: this.allDataVar.map((item) => ({
    //   ...item,
    //   ScrapQty: 0,
    //   WastageQty: 0,
    //   AcceptedQty: 0,
    //   ConsumptionQty: 0, // Initially set to 0 or the desired initial value
    // })),
  };

  componentDidMount() {
    console.log(
      "componentDidMount Ran ---------------------------------------------------------------"
    );
    GlobalValues();

    console.log(companyCode); //undefined
    console.log(FSessionId); //undefined

    this.waitForResponse();
  }

  waitForResponse = async () => {
    if (
      typeof companyCode === "undefined" &&
      typeof FSessionId === "undefined" &&
      typeof InDocNo === "undefined" &&
      typeof JobWorkRefNo === "undefined" &&
      typeof InDate === "undefined"
    ) {
      setTimeout(this.waitForResponse, 500);
    } else {
      console.log("App-companyCode: ", companyCode);
      console.log("App-FSessionId: ", FSessionId);
      console.log("App-InDocNo : ", InDocNo);
      console.log("App-OutReferenceDocNo : ", JobWorkRefNo);
      console.log("App-InDate : ", InDate);

      //Calling All the preload API here.
      await this.getAllData();
      await this.getAllHeaders();
      this.setState({ isLoading: false });
    }
  };

  allDataVar = [];

  getAllData = async () => {
    const url = ` ${host}/node/allGridDetails?companyCode=${companyCode}&OutDocNo=${JobWorkRefNo}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      console.log("AllData json Converted data : ", data);
      this.allDataVar = data.recordset;
      console.log("AllData : ", this.allDataVar);
    } catch (error) {
      console.log(
        "Error Occured while calling the getAllData function : ",
        error.message
      );
    }
  };

  getAllHeaders = async () => {
    console.log("modifiedJobWorkRefNo : ", modifiedJobWorkRefNo);
    const url = `/focus8api/Screen/Transactions/6145/${modifiedJobWorkRefNo}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-cache",
        headers: {
          fSessionId: FSessionId,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      console.log("AllHeaders json Converted data : ", data);

      console.log("AllHeaders : ", data.data[0].Header);
      this.setState({
        HeaderData: data.data[0].Header,
      });
    } catch (error) {
      console.log(
        "Error Occured while calling the AllHeaders function : ",
        error.message
      );
    }
  };

  handleInputChange = (index, field, event) => {
    const inputValue = event.target.value;
    const alreadyConsumed = parseInt(this.allDataVar[index].BalQty, 10);
    let updatedValue;

    // If the input value is an empty string, set updatedValue to an empty string
    if (inputValue === "") {
      updatedValue = "";
    } else {
      // Check if the input value is a valid number
      if (!isNaN(inputValue)) {
        updatedValue = parseInt(inputValue, 10);
      } else {
        updatedValue = 0; // Set to 0 if the input is not a number
      }
    }

    const updatedGridData = [...this.allDataVar];
    updatedGridData[index][field] = updatedValue;

    // Calculate new ConsumptionQty
    let consumptionQty;

    // Check if the field being updated is ConsumptionQty
    if (field === "ConsumptionQty") {
      consumptionQty = updatedValue;
    } else {
      // Sum the fields to calculate ConsumptionQty
      const { ScrapQty, WastageQty, RejectedQty, AcceptedQty } =
        updatedGridData[index];
      consumptionQty =
        (ScrapQty || 0) +
        (WastageQty || 0) +
        (RejectedQty || 0) +
        (AcceptedQty || 0);
    }

    // Check if the calculated ConsumptionQty is within the allowed limit
    if (consumptionQty <= alreadyConsumed) {
      updatedGridData[index].ConsumptionQty = consumptionQty;
      this.setState({ FinalData: updatedGridData });
      this.allDataVar = updatedGridData;
    } else {
      // Reset the input value if the input exceeds the allowed limit
      event.target.value = updatedGridData[index][field];
      alert("The total quantity cannot exceed the already consumed quantity.");
    }
  };

  handlePost = async () => {
    console.log("Posting Button Clicked");
    const { HeaderData } = this.state;
    console.log("HeaderData : ", HeaderData);
    console.log("allDataVar : ", this.allDataVar);
    let finalPostingArray = [];

    //validation for empty Accepted Qty field------------------------
    const zeroCheckerAcceptedQty = [];

    this.allDataVar.forEach((obj, index) => {
      if (obj.AcceptedQty == 0) {
        zeroCheckerAcceptedQty.push(index + 1); //+1 cuz array index starts from 0
      }
    });

    let RowIndexes = zeroCheckerAcceptedQty.join();

    if (this.allDataVar.length === 0) {
      alert("No Data to Post");
      return;
    } else if (zeroCheckerAcceptedQty.length !== 0) {
      alert(
        `Accepted Quantity can't be left empty. Please check row numbers : ${RowIndexes} `
      );
      return;
    } else {
      for (let i = 0; i < this.allDataVar.length; i++) {
        const consumptionQty = this.allDataVar[i].ConsumptionQty;
        console.log(
          "this.allDataVar[i].ConsumptionQty : ",
          this.allDataVar[i].ConsumptionQty
        );
        if (consumptionQty !== 0 && String(consumptionQty) !== "") {
          finalPostingArray.push(this.allDataVar[i]);
        }
      }
    }

    console.log("Final Posting Array : ", finalPostingArray);

    if (finalPostingArray.length === 0) {
      alert("No Data to Post");
      return;
    }

    this.setState({ isLoading: true });

    let BodyBindedArray = [];
    let singleBody = {};
    let HeaderBindedObj = {};

    var postingIntDate =
      new Date().getDate() +
      (new Date().getMonth() + 1) * 256 +
      new Date().getFullYear() * 65536;

    if (HeaderData.Attachment === "" || HeaderData.Attachment === null) {
      HeaderBindedObj = {
        DocNo: HeaderData.DocNo,
        Date: postingIntDate,
        Location__Id: HeaderData.Location__Id, //branch
        CustomerAC__Id: HeaderData.CustomerAC__Id, //vendor account
        LocalVendor: HeaderData.LocalVendor,
        sNarration: HeaderData.sNarration,
        PlaceofSupply__Id: HeaderData.PlaceofSupply__Id,
        RefDoc: InDocNo,
        RefDate: InDate,
        JobWorkChallanOutNo_: HeaderData.DocNo,
        IsIGST: HeaderData.IsIGST,

        /*       Attachment:
            HeaderData.Attachment === "" || HeaderData.Attachment === null
              ? ""
              : {
                  FileName: `${HeaderData.Attachment.FileName}`,
                  FileData: `${HeaderData.Attachment.FileData}`,
                }, */
      };
    } else {
      HeaderBindedObj = {
        DocNo: HeaderData.DocNo,
        Date: postingIntDate,
        Location__Id: HeaderData.Location__Id, //branch
        CustomerAC__Id: HeaderData.CustomerAC__Id, //vendor account
        LocalVendor: HeaderData.LocalVendor,
        sNarration: HeaderData.sNarration,
        PlaceofSupply__Id: HeaderData.PlaceofSupply__Id,
        RefDoc: InDocNo,
        RefDate: InDate,
        JobWorkChallanOutNo_: HeaderData.DocNo,
        IsIGST: HeaderData.IsIGST,

        Attachment: {
          FileName: `${HeaderData.Attachment.FileName}`,
          FileData: `${HeaderData.Attachment.FileData}`,
        },
      };
    }

    for (let i = 0; i < finalPostingArray.length; i++) {
      singleBody = {
        Warehouse__Id: finalPostingArray[i].iWarehouse,
        "Segment Master__Id": finalPostingArray[i].iSegment,
        "Color Master__Id": finalPostingArray[i].iColor,
        Item__Id: finalPostingArray[i].iProduct,
        Description: finalPostingArray[i].Description,
        HSN_SAC: finalPostingArray[i].HSN_SAC,
        ItemDescription: finalPostingArray[i].ItemDescription,
        "L-Job Work Challan Out": [
          {
            BaseTransactionId: `${finalPostingArray[i].irefID}`,
            VoucherType: 6145,
            VoucherNo: `${finalPostingArray[i].Link}`,
            UsedValue: `${finalPostingArray[i].ConsumptionQty}`,
            LinkId: 402724872,
            RefId: `${finalPostingArray[i].irefID}`,
          },
        ],
        Unit__Id: finalPostingArray[i].iUnit,
        Quantity: finalPostingArray[i].ConsumptionQty,
        Rate: finalPostingArray[i].mRate,
        Gross: finalPostingArray[i].Gross,
        "Scrap Quantity": {
          Input: `${finalPostingArray[i].ScrapQty}`,
          FieldName: "Scrap Quantity",
          FieldId: 772,
          ColMap: 9,
          // "Value": 2.0000000000
        },
        "Wastage Quantity": {
          Input: `${finalPostingArray[i].WastageQty}`,
          FieldName: "Wastage Quantity",
          FieldId: 773,
          ColMap: 10,
          // "Value": 10.0000000000
        },
        "Rejected Quantity": {
          Input: `${finalPostingArray[i].RejectedQty}`,
          FieldName: "Rejected Quantity",
          FieldId: 774,
          ColMap: 11,
          // "Value": 3.0000000000
        },
        "Accepted Quantity": {
          Input: `${finalPostingArray[i].AcceptedQty}`,
          FieldName: "Accepted Quantity",
          FieldId: 775,
          ColMap: 12,
          // "Value": 4.0000000000
        },
        Discount: {
          Input: `${finalPostingArray[i].Discount}`,
          FieldName: "Discount",
          FieldId: 534,
          ColMap: 0,
          // "Value": 0.0000
        },
        "Freight Charges": {
          Input: `${finalPostingArray[i]["Freight Charges"]}`,
          FieldName: "Freight Charges",
          FieldId: 540,
          ColMap: 6,
          // "Value": 0.0000000000
        },
        "Other Charges": {
          Input: `${finalPostingArray[i]["Other Charges"]}`,
          FieldName: "Other Charges",
          FieldId: 541,
          ColMap: 7,
          // Value: 0.0,
        },
        // "Taxable Value": {
        //   Input: ``,
        //   FieldName: "Taxable Value",
        //   FieldId: 535,
        //   ColMap: 1,
        //   // Value: 10000.0,
        // },
        CGST: {
          Input: `${finalPostingArray[i]["CGST"]}`,
          FieldName: "CGST",
          FieldId: 536,
          ColMap: 2,
          // Value: 0.0,
        },
        SGST: {
          Input: `${finalPostingArray[i]["SGST"]}`,
          FieldName: "SGST",
          FieldId: 537,
          ColMap: 3,
          // Value: 0.0,
        },
        IGST: {
          Input: `${finalPostingArray[i]["IGST"]}`,
          FieldName: "IGST",
          FieldId: 538,
          ColMap: 4,
          // Value: 1800.0,
        },
        sRemarks: finalPostingArray[i].sRemarks,
      };

      BodyBindedArray.push(singleBody);
    }

    let PostingBody = {
      data: [
        {
          Body: BodyBindedArray,
          Header: HeaderBindedObj,
        },
      ],
    };

    let PostingURL = `/focus8api/Transactions/6152`;
    let PostingOption = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        fSessionId: FSessionId,
      },
      body: JSON.stringify(PostingBody),
    };
    console.log("PostingOption : ", PostingOption);

    try {
      const postingRes = await fetch(PostingURL, PostingOption);
      console.log("postingRes : ", postingRes);
      const jsonPostingRes = await postingRes.json();
      console.log("jsonPostingRes : ", jsonPostingRes);
      if (jsonPostingRes.result === 1) {
        // alertArraySuccess.push(jsonPostingRes.data[0].VoucherNo);
        console.log("Posting to Job Work Challan Consumption Successful");
        alert("Posting to Job Work Challan Consumption Successful");
        this.setState({ isLoading: false });
        // this.closeModule();
        Focus8WAPI.closePopup();
        Focus8WAPI.continueModule(
          Focus8WAPI.ENUMS.MODULE_TYPE.TRANSACTION,
          true
        );
      } else {
        console.log(
          `HTTP error! status: ${jsonPostingRes.message} while posting to Job Work Challan Consumption`
        );
        alert(
          `HTTP error! status: ${jsonPostingRes.message} while posting to Job Work Challan Consumption`
        );

        this.setState({ isLoading: false });
        return;
      }
    } catch (error) {
      console.log(
        "Error occured while posting to Job Work Challan Consumption : ",
        error
      );
      alert("Error occured while posting to Job Work Challan Consumption ");
      this.setState({ isLoading: false });
      return;
    }
  };

  //close Module code
  closeModule = () => {
    const isClose = window.confirm("Do you want to close this Module");

    if (isClose === true) {
      Focus8WAPI.closePopup();
    } else {
      return;
    }
  };

  render() {
    const { isLoading, FinalData, HeaderData } = this.state;
    console.log("FinalData State : ", FinalData, "HeaderData : ", HeaderData);
    return (
      <div className="Main-Component">
        {isLoading && <Spinner size={200} color="#2db9fc" />}
        <h3 id="main-header">Job Work Challan Consumption Posting</h3>
        <hr />
        <div id="top-component" className="col-12 d-flex">
          <div
            id="top-firsthalf"
            className="col-6 d-flex align-items-center justify-content-start"
          >
            <label id="OutDocNo-label" style={{ marginRight: "5px" }}>
              Job Work Challan Out :
            </label>
            <input
              id="OutDocNo-input"
              type="text"
              value={JobWorkRefNo}
              disabled
            />
          </div>
        </div>
        <div id="bottom-component">
          {/* This is the Table component */}
          <table id="main-table">
            <thead>
              <tr className="">
                <th className="t-head-cell">Item Name</th>
                <th className="t-head-cell">Item Code</th>
                <th className="t-head-cell">Old Erp Code</th>
                <th className="t-head-cell">Job Work Out Qty</th>
                <th className="t-head-cell">Already Consumed</th>
                <th className="t-head-cell">Scrap Qty</th>
                <th className="t-head-cell">Wastage Qty</th>
                <th className="t-head-cell">Rejected Qty</th>
                <th className="t-head-cell">Accepted Qty</th>
                <th className="t-head-cell">Consumption Qty</th>
              </tr>
            </thead>
            <tbody id="table-tbody">
              {this.allDataVar.map((item, index) => (
                <tr key={index} className="tr-tablerow">
                  <td className="table-data">{item.sProduct}</td>
                  <td className="table-data">{item.ItemCode}</td>
                  <td className="table-data">{item.oldERPCode}</td>
                  <td className="table-data" style={{ textAlign: "right" }}>
                    {item.fQty}
                  </td>
                  <td className="table-data" style={{ textAlign: "right" }}>
                    {item.CQty}
                  </td>
                  <td className="table-data">
                    <input
                      className="num-input"
                      type="number"
                      min={0}
                      value={item.ScrapQty}
                      onChange={(event) =>
                        this.handleInputChange(index, "ScrapQty", event)
                      }
                    />
                  </td>
                  <td className="table-data">
                    <input
                      className="num-input"
                      type="number"
                      min={0}
                      value={item.WastageQty}
                      onChange={(event) =>
                        this.handleInputChange(index, "WastageQty", event)
                      }
                    />
                  </td>
                  <td className="table-data">
                    <input
                      className="num-input"
                      type="number"
                      min={0}
                      value={item.RejectedQty}
                      onChange={(event) =>
                        this.handleInputChange(index, "RejectedQty", event)
                      }
                    />
                  </td>
                  <td className="table-data">
                    <input
                      className="num-input"
                      type="number"
                      min={0}
                      required
                      value={item.AcceptedQty}
                      onChange={(event) =>
                        this.handleInputChange(index, "AcceptedQty", event)
                      }
                    />
                  </td>
                  <td className="table-data">
                    <input
                      className="num-input"
                      type="number"
                      min={0}
                      value={item.ConsumptionQty}
                      onChange={(event) =>
                        this.handleInputChange(index, "ConsumptionQty", event)
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div
          id="bottom-component "
          style={{ marginTop: "20px" }}
          className="d-flex align-items-center justify-content-center"
        >
          <button className="btn" id="btn-close" onClick={this.closeModule}>
            Close
          </button>
          <button className="btn" id="btn-post" onClick={this.handlePost}>
            Post
          </button>
        </div>
      </div>
    );
  }
}

export default App;
